<template>
    <b-container fluid>
        <b-overlay :show="customLoading" rounded="sm">
            <iq-card>
                <template v-slot:body>
                    <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                        <b-form  @submit.prevent="handleSubmit(storeTrainer)" @reset.prevent="reset" enctype="multipart/form-data">
                            <b-row>
                                <b-col xs="12" sm="12" md="6" >
                                    <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="fiscal_year_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                                {{ $t('globalTrans.fiscal_year') }} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                                plain
                                                v-model="formData.fiscal_year_id"
                                                id="fiscal_year_id"
                                                :options="fiscalYearList"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xs="12" sm="12" md="6" >
                                    <ValidationProvider name="Circular" vid="circular_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="circular_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                                {{ $t('trainer_trainee.circular_memo_no') }} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                                plain
                                                v-model="formData.circular_id"
                                                id="circular_id"
                                                :options="circularMemoList"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xs="12" sm="12" md="6" >
                                    <ValidationProvider name="Training title" vid="training_title_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="training_title_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                                {{ $t('trainer_trainee.training_title') }} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="formData.training_name_id"
                                            id="training_title_id"
                                            :options="trainingTitleList"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xs="12" sm="12" md="6">
                                  <b-spinner v-if="moduleSpinLoader" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                    <ValidationProvider name="Batch" vid="batch_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="batch_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                                {{ $t('trainer_trainee.batch') }} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="formData.batch_id"
                                            id="batch_id"
                                            :options="batchList"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xs="12" sm="12" md="6">
                                    <ValidationProvider name="Honorarium Amount" vid="honorarium_amount" rules="required|min_value:0">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="honorarium_amount"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                                {{$t('trainer_trainee.allowance')}}<span class="text-danger">*</span>
                                            </template>
                                            <b-form-input
                                            type="number"
                                            v-model="formData.allowance_amount"
                                            :placeholder="$t('trainer_trainee.allowance')"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xs="12" sm="12" md="6">
                                    <ValidationProvider name="Transport Cost Amount" vid="income_tax" rules="required|min_value:0">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="income_tax"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                                {{$t('trainer_trainee.ta_da')}}<span class="text-danger">*</span>
                                            </template>
                                            <b-form-input
                                            type="number"
                                            v-model="formData.ta_da_amount"
                                            :placeholder="$t('trainer_trainee.ta_da')"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col  xs="12" sm="12" md="6">
                                    <ValidationProvider name="Application Date" vid="apply_date" rules="required">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="apply_date"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                                {{$t('elearning_config.application_date')}}<span class="text-danger">*</span>
                                            </template>
                                            <b-form-input
                                            id="apply_date"
                                            class="date-picker"
                                            v-model="formData.apply_date"
                                            :placeholder="$t('globalTrans.select_date')"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12" class="mt-3">
                                    <table class="table table-bordered">
                                        <thead style="background-color: #e0e0de">
                                        <tr style="background-color: #e0e0de">
                                            <th>{{ $t('elearning_config.name')}}</th>
                                            <th>{{ $t('elearning_config.designation') }}</th>
                                            <th>{{ $t('trainer_trainee.org_name') }}</th>
                                            <th>{{ $t('trainer_trainee.total_day') }}</th>
                                            <th>{{ $t('trainer_trainee.allowance') }}</th>
                                            <th>{{ $t('trainer_trainee.ta_da') }}</th>
                                            <th>{{ $t('trainer_trainee.sub_total') }}</th>
                                            <th>{{ $t('trainer_trainee.deduction') }}</th>
                                            <th>{{ $t('trainer_trainee.total') }}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <b-tr v-for="(item, index) in listData" :key="index">
                                            <td>{{ currentLocale === 'bn'? item.name_bn : item.name_en}}</td>
                                            <td>{{ item.other_designation ? item.other_designation : (currentLocale === 'en'? item.designation : item.designation_bn) }}</td>
                                            <!-- <td>{{ currentLocale === 'bn'? item.designation_bn : item.designation }}</td> -->
                                            <td>{{  currentLocale === 'bn'? item.organization_bn : item.organization }} </td>
                                            <td>
                                                <b-form-input
                                                    id="apply_date"
                                                    class="date-picker"
                                                    v-model="item.total_class"
                                                    type="number"
                                                    min="1"
                                                    @input="ChangeCheck(index, 5, item.total_class)"
                                                    :placeholder="$t('globalTrans.select_date')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input
                                                    id="apply_date"
                                                    class="date-picker"
                                                    v-model="item.allowance_amount"
                                                    type="number"
                                                    min="0"
                                                    @input="ChangeCheck(index, 1, item.allowance_amount)"
                                                    :placeholder="$t('globalTrans.select_date')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                {{item.ta_da_amount}}
                                            </td>
                                            <td>
                                                {{item.sub_total}}
                                            </td>
                                            <td>
                                                <b-form-input
                                                    id="apply_date"
                                                    class="date-picker"
                                                    type="number"
                                                    min="0"
                                                    @input="ChangeCheck(index, 3, item.deduction_amount)"
                                                    v-model="item.deduction_amount"
                                                    :placeholder="$t('globalTrans.select_date')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                {{item.total}}
                                            </td>
                                        </b-tr>
                                        <b-tr v-if="listData.length < 1">
                                            <td colspan="10" class="align-middle text-center">{{ $t('globalTrans.noDataFound') }}</td>
                                        </b-tr>
                                        </tbody>
                                    </table>
                                </b-col>
                            </b-row>
                            <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button type="submit" variant="primary" class="mr-1">{{ saveBtnName }}</b-button>
                                    &nbsp;
                                    <b-button type="button" variant="danger" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                </div>
                            </div>
                        </b-form>
                    </ValidationObserver>
                </template>
            </iq-card>
        </b-overlay>
    </b-container>
</template>
<script>
    import { ValidationObserver, ValidationProvider } from 'vee-validate'
    import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
    import {
        traineeBatchListApi,
        allowanceUpdateApi,
        allowanceStoreApi
    } from '../../api/routes'
    import flatpickr from 'flatpickr'
    import { circularDataApi } from '../../../training-plan-management/api/routes'

    export default {
        props: ['item', 'id'],
        components: {
            ValidationObserver,
            ValidationProvider
        },
        data () {
            return {
                saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
                formData: {
                    fiscal_year_id: 0,
                    circular_id: 0,
                    training_name_id: 0,
                    batch_id: 0,
                    allowance_amount: 0,
                    ta_da_amount: 0,
                    apply_date: null
                },
                circularMemoList: [],
                trainingTitleList: [],
                listData: [],
                batchList: [],
                customLoading: false,
                moduleSpinLoader: false
            }
        },
        mounted () {
            flatpickr('#apply_date', { minDate: 'today' })
        },
        computed: {
            fiscalYearList: function () {
                return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
            },
            currentLocale () {
                return this.$i18n.locale
            }
        },
        watch: {
            'formData.fiscal_year_id': function (newVal, oldVal) {
                if (!this.item) {
                    this.formData.circular_id = 0
                    this.formData.training_name_id = 0
                }

                this.circularMemoList = this.getMomoList(newVal)
                this.trainingTitleList = []
                this.batchList = []
              // this.formData.batch_id = 0
            },
            'formData.circular_id': function (newVal, oldVal) {
                if (!this.item) {
                    this.formData.training_name_id = 0
                }
                this.trainingTitleList = this.getTrainingTitle(newVal)
              // this.formData.batch_id = 0
                if (newVal !== oldVal) {
                  this.getCircularData()
                }
            },
            'formData.training_name_id': function (newVal, oldVal) {
               if (this.formData.batch_id > 0) {
                   this.loadData()
               }
            },
            'formData.batch_id': function (newVal, oldVal) {
               if (this.formData.training_name_id > 0) {
                   this.loadData()
               }
            },
            'formData.allowance_amount': function (newVal, oldVal) {
                this.listData.forEach((element, index) => {
                     this.listData[index].allowance_amount = parseFloat(newVal).toFixed(2)
                     this.Calculation(index)
               })
            },
            'formData.ta_da_amount': function (newVal, oldVal) {
                this.listData.forEach((element, index) => {
                    this.listData[index].ta_da_amount = parseFloat(newVal).toFixed(2)
                    this.Calculation(index)
                })
            }
        },
        created () {
            if (this.item) {
                this.formData.main_id = this.item.id
                this.formData.fiscal_year_id = this.item.fiscal_year_id
                this.formData.circular_id = this.item.circular_publication_id
                this.formData.training_name_id = this.item.training_title_id
                this.formData.batch_id = this.item.batch_id
                this.formData.allowance_amount = this.item.allowance_amount
                this.formData.ta_da_amount = this.item.ta_da_amount
                this.formData.ta_da_amount = this.item.ta_da_amount
                this.formData.apply_date = this.item.application_date
            } else {
              this.formData.main_id = null
              this.formData.fiscal_year_id = 0
              this.formData.circular_id = 0
              this.formData.training_name_id = 0
              this.formData.batch_id = 0
              this.formData.allowance_amount = 0
              this.formData.ta_da_amount = 0
              this.formData.apply_date = null
            }
        },
        methods: {
            formatdata (data) {
                const info = []
               data.forEach((element, index, array) => {
                   info.push({
                       id: null,
                       trainee_id: data.trainer_profile_id,
                       application_id: data.application_id,
                       name_en: data.trainer.name,
                       name_bn: data.trainer.name_bn,
                       designation: data.trainer.designation_id,
                       other_designation: data.trainer.other_designation,
                       organization: data.trainer.org_name,
                       contact_no: data.trainer.mobile_no,
                       total_class: data.mobile_no,
                       honorarium: data.honorarium_amount,
                       ta_da_amount: data.mobile_no,
                       tax_amount: data.mobile_no,
                       sub_total: data.mobile_no,
                       deduction_amount: data.deduction_amount,
                       total: data.mobile_no
                   })
               })
               return info
            },
            getDesignation (id) {
              const info = this.$store.state.TrainingElearning.commonObj.designationList.find(item => item.value === id)
                  if (this.$i18n.locale === 'bn') {
                      return info.text_bn
                  } else {
                      return info.text_en
                  }
            },
            ChangeCheck (index, type, target) {
                if (type === 1) {
                    this.listData[index].allowance_amount = target
               }
                if (type === 2) {
                    this.listData[index].ta_da_amount = target
                }
                if (type === 5) {
                    this.listData[index].total_class = target
                }
                if (type === 3) {
                    this.listData[index].deduction_amount = target
                }
                this.Calculation(index)
            },
            Calculation (index) {
                const classAmount = this.listData[index].total_class
                const honorarium = parseFloat(this.listData[index].allowance_amount * classAmount)
                const tadaamount = parseFloat(this.listData[index].ta_da_amount)
                const deduction = this.listData[index].deduction_amount
                const sub = honorarium + tadaamount
                const total = sub - deduction
               this.listData[index].sub_total = parseFloat(sub).toFixed(2)
                this.listData[index].total = parseFloat(total).toFixed(2)
            },
            async storeTrainer () {
                this.customLoading = true
                this.$store.dispatch('mutateCommonProperties', { loading: true })
                let result = null
                const loadinState = { loading: false, listReload: true }
                this.formData.details = this.listData
                if (this.item.id) {
                    result = await RestApi.putData(trainingElearningServiceBaseUrl, `${allowanceUpdateApi}/${this.item.id}`, this.formData)
                } else {
                    result = await RestApi.postData(trainingElearningServiceBaseUrl, allowanceStoreApi, this.formData)
                }
                this.$store.dispatch('mutateCommonProperties', loadinState)

                if (result.warning) {
                    this.customLoading = false
                    this.$toast.error({
                        title: 'warning',
                        message: result.message
                    })
                    return
                }

                if (result.success) {
                    this.$store.commit('TrainingElearning/mutateCommonObj', { hasDropdownLoaded: false })
                    this.$toast.success({
                        title: 'Success',
                        message: this.id ? 'Data updated successfully' : 'Data save successfully',
                        color: '#D6E09B'
                    })
                    this.$bvModal.hide('modal-4')
                } else {
                    this.$refs.form.setErrors(result.errors)
                    this.$toast.error({
                        title: 'Error',
                        message: 'Operation failed! Please, try again.'
                    })
                }
            },
            getMomoList (fiscalYearId) {
                return this.$store.state.TrainingElearning.commonObj.circularMemoList.filter(item => item.fiscal_year_id === fiscalYearId).map(item => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: item.value, text: item.text_bn }
                    } else {
                        return { value: item.value, text: item.text_en }
                    }
                })
            },
            getTrainingTitle (circularMemoId) {
                const trainingObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
                if (trainingObj !== undefined) {
                    return this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1 && item.value === trainingObj.training_title_id).map(item => {
                        if (this.$i18n.locale === 'bn') {
                            return { value: item.value, text: item.text_bn }
                        } else {
                            return { value: item.value, text: item.text_en }
                        }
                    })
                }
            },
            loadData () {
                this.customLoading = true
               RestApi.getData(trainingElearningServiceBaseUrl, traineeBatchListApi, this.formData).then(response => {
                    if (response.success) {
                        if (this.item.details) {
                            const info = []
                            response.data.forEach((element, index) => {
                                this.item.details.forEach((element2, index2) => {
                                    if (element.trainee_main_id === element2.trainee_main_id) {
                                        info.push({
                                            id: element2.id,
                                            trainee_id: element.trainee_main_id,
                                            application_id: element.application_id,
                                            name_en: element.name_en,
                                            name_bn: element.name_bn,
                                          designation: element.designation,
                                          designation_bn: element.designation_bn,
                                          organization: element.organization,
                                          organization_bn: element.organization_bn,
                                            contact_no: element.contact_no,
                                            total_class: element2.total_class,
                                            allowance_amount: element2.allowance_amount,
                                            ta_da_amount: element2.ta_da_amount,
                                            sub_total: parseFloat(element2.allowance_amount) + parseFloat(element2.ta_da_amount),
                                            deduction_amount: element2.deduction_amount,
                                            total: element2.total_amount
                                        })
                                    }
                                })
                            })
                            this.listData = info
                        } else {
                            this.listData = response.data
                        }
                    } else {
                        this.listData = []
                        this.$toast.error({
                            title: this.$t('globalTrans.noDataFound'),
                            message: '',
                            color: '#D6E09B'
                        })
                    }
                   this.customLoading = false
                })
            },
            async getCircularData () {
              if (this.formData.fiscal_year_id && this.formData.circular_id) {
                this.moduleSpinLoader = true
                const result = await RestApi.getData(trainingElearningServiceBaseUrl, circularDataApi, { fiscal_year_id: this.formData.fiscal_year_id, circular_id: this.formData.circular_id })
                if (result.success) {
                  this.formData.training_name_id = result.training
                  this.batchList = result.batch.map((item, index) => {
                    return Object.assign({}, { value: item.batch_d.id, text: item.batch_d.batch, text_bn: item.batch_d.batch_bn })
                  })
                  this.moduleSpinLoader = false
                }
              }
            }
        }
    }
</script>
<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
</style>
